"use strict";
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BespokeAssignmentProvider = exports.AssignmentStatus = void 0;
var AssignmentStatus;
(function (AssignmentStatus) {
    AssignmentStatus["LIVE"] = "live";
    AssignmentStatus["CLOSED"] = "closed";
    AssignmentStatus["TRASH"] = "trash";
})(AssignmentStatus = exports.AssignmentStatus || (exports.AssignmentStatus = {}));
var BespokeAssignmentProvider;
(function (BespokeAssignmentProvider) {
    BespokeAssignmentProvider["HAND_IN"] = "hand-in";
    BespokeAssignmentProvider["TURNITIN"] = "turnitin";
    BespokeAssignmentProvider["QUIZZES"] = "quizzes";
    BespokeAssignmentProvider["MANUAL"] = "manual";
})(BespokeAssignmentProvider = exports.BespokeAssignmentProvider || (exports.BespokeAssignmentProvider = {}));
